import { useEffect, useState } from 'react';

import { Input } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';

export const VideoLength = observer(() => {
  const es = useStores().trackmanEventsEditorStore;
  const [hours, setHours] = useState(() => {
    const [h] = (es.eventItem.videoLength ?? '').split(':');
    return h;
  });

  const [minutes, setMinutes] = useState(() => {
    const [, m] = (es.eventItem.videoLength ?? '').split(':');
    return m;
  });

  useEffect(() => {
    if (hours && minutes) {
      es.eventItem.videoLength = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:00`;
    }
  }, [hours, minutes, es]);

  return (
    <div className='admin-edit-section'>
      <h2>Recording length*</h2>
      <div className='inputs-container video-length'>
        <Input label='Hours' value={hours ?? ''} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setHours(e.currentTarget.value)} />
        <Input
          label='Minutes'
          value={minutes ?? ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMinutes(e.currentTarget.value)}
        />
      </div>
    </div>
  );
});

export default VideoLength;
